(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["date-picker-snippet-pdp"] && !Shopify.designMode) return;
  try {
    function populateDatePicker(event) {
    let form = null;
    // Prefer a form that is closest to the event target (e.g. after product:reloaded)
    if (event && event.target && typeof event.target.closest === 'function') {
      form = event.target.closest('form[data-type="add-to-cart-form"]');
    }
    // Fallback to a global query if we didn't find a form via the event
    if (!form) {
      form = document.querySelector('form[data-type="add-to-cart-form"]');
    }

    if (!form) {
      return;
    }

    function isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function getDaysInMonth(month, year) {
      if (!month || !year) return 31; // Default to 31 days initially
      const monthIndex = months.findIndex((m) => m.full === month);
      if (monthIndex === 1) {
        return isLeapYear(year) ? 29 : 28; // February
      }
      return [3, 5, 8, 10].includes(monthIndex) ? 30 : 31; // Months with 30 days
    }

    const months = [
      { full: 'January', short: 'Jan' },
      { full: 'February', short: 'Feb' },
      { full: 'March', short: 'Mar' },
      { full: 'April', short: 'Apr' },
      { full: 'May', short: 'May' },
      { full: 'June', short: 'Jun' },
      { full: 'July', short: 'Jul' },
      { full: 'August', short: 'Aug' },
      { full: 'September', short: 'Sep' },
      { full: 'October', short: 'Oct' },
      { full: 'November', short: 'Nov' },
      { full: 'December', short: 'Dec' },
    ];

    let selectedMonth = '';
    let selectedYear = '';
    let selectedDay = '';

    const dayContainer = document.getElementById('days-container');
    const monthContainer = document.getElementById('month-container');
    const yearContainer = document.getElementById('year-container');
    const dayText = document.querySelector('.day-text');
    const monthText = document.querySelector('.month-text');
    const yearText = document.querySelector('.year-text');

    // Hidden input fields
    const hiddenDayInput = document.getElementById('hidden-day');
    const hiddenMonthInput = document.getElementById('hidden-month');
    const hiddenYearInput = document.getElementById('hidden-year');
    const errorMessage = document.querySelector('.date-input-error'); // Error message container

    function updateHiddenInputs() {
      const monthIndex =
        months.findIndex((x) => x.full == selectedMonth) + 1 || months.findIndex((x) => x.short == selectedMonth) + 1;
      const monthInNumber = monthIndex;
      const newSelectedMonth = monthInNumber !== 0 ? monthInNumber.toString().padStart(2, '0') : '';

      hiddenDayInput.value = selectedDay || '';
      hiddenMonthInput.value = newSelectedMonth || '';
      hiddenYearInput.value = selectedYear || '';

      if (typeof window.toggleButtonState === 'function') {
        window.toggleButtonState();
      }
    }

    function updateDays() {
      const numberOfDays = getDaysInMonth(selectedMonth, selectedYear);
      dayContainer.innerHTML = '';

      for (let i = 1; i <= numberOfDays; i++) {
        const dayDiv = document.createElement('div');
        dayDiv.className = 'sub-child cursor-pointer p-[10px] hover:bg-ink-3';
        dayDiv.textContent = i.toString().padStart(2, '0');

        dayDiv.addEventListener('click', function () {
          selectedDay = this.textContent;
          dayText.textContent = this.textContent;
          dayText.classList.add('text-ink');
          this.closest('.dpdetails').removeAttribute('open');
          updateHiddenInputs(); // Update hidden inputs
          hideErrorMessage(); // Hide the error message when a day is selected
        });

        dayContainer.appendChild(dayDiv);
      }

      // Adjust selectedDay if it exceeds the number of days in the new month/year
      if (selectedDay && parseInt(selectedDay) > numberOfDays) {
        selectedDay = numberOfDays.toString().padStart(2, '0');
        dayText.textContent = selectedDay;
      }

      updateHiddenInputs(); // Update hidden inputs
    }

    function updateMonthDisplay() {
      const isMobile = window.innerWidth <= 768; // Define breakpoint for mobile
      monthContainer.innerHTML = '';

      months.forEach((month) => {
        const monthDiv = document.createElement('div');
        monthDiv.className = 'sub-child cursor-pointer p-[10px] hover:bg-ink-3';
        monthDiv.textContent = isMobile ? month.short : month.full;

        monthDiv.addEventListener('click', function () {
          selectedMonth = month.full; // Use full name for backend purposes
          monthText.textContent = this.textContent;
          monthText.classList.add('text-ink');
          this.closest('.dpdetails').removeAttribute('open');
          updateDays(); // Update days based on the new month
          updateHiddenInputs(); // Update hidden inputs
          hideErrorMessage(); // Hide error message when a month is selected
        });

        monthContainer.appendChild(monthDiv);
      });
    }

    // Populate years dropdown
    const currentYear = new Date().getFullYear();
    const lastAvailableYearField = document.querySelector('[data-last-available-year]');
    const lastAvailableYear = lastAvailableYearField ? Number(lastAvailableYearField.value) : 1925;
    const totalNumberOfYears = currentYear - (lastAvailableYear - 1);
    for (let i = 0; i < totalNumberOfYears; i++) {
      const year = currentYear - i;
      const yearDiv = document.createElement('div');
      yearDiv.className = 'sub-child cursor-pointer p-[10px] hover:bg-ink-3';
      yearDiv.textContent = year;

      yearDiv.addEventListener('click', function () {
        selectedYear = this.textContent;
        yearText.textContent = this.textContent;
        yearText.classList.add('text-ink');
        this.closest('.dpdetails').removeAttribute('open');
        updateDays(); // Update days based on the new year
        updateHiddenInputs(); // Update hidden inputs
        hideErrorMessage(); // Hide error message when a year is selected
      });

      yearContainer.appendChild(yearDiv);
    }

    // Function to check if all required date fields are selected
    function validateDateFields() {
      if (!selectedDay || !selectedMonth || !selectedYear) {
        showErrorMessage(); // Show error if any field is missing
        return false; // Prevent form submission
      }
      return true; // Allow form submission if all fields are selected
    }

    function showErrorMessage() {
      errorMessage.style.display = 'block'; // Show error message
    }

    function hideErrorMessage() {
      errorMessage.style.display = 'none'; // Hide error message
    }

    // Initialize with default 31 days
    updateDays();
    updateMonthDisplay(); // Populate month dropdown

    // Update month display on window resize (bind only once)
    if (!window.__datePickerResizeBound) {
      window.addEventListener('resize', updateMonthDisplay);
      window.__datePickerResizeBound = true;
    }

    // Example form validation (on submit, for instance)
    form.addEventListener('submit', function (event) {
      if (!validateDateFields()) {
        event.preventDefault(); // Prevent form submission if date is invalid
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.dpdetails')) {
      document.querySelectorAll('.dpdetails').forEach((detail) => {
        detail.removeAttribute('open');
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    populateDatePicker();
    // Bind only once even if snippet is included multiple times
    if (!window.__productDatePicker) {
      window.__productDatePicker = true;
      document.addEventListener('product:reloaded', populateDatePicker);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp_header"] && !Shopify.designMode) return;
  try {
    async function pdpSwapProduct(handle, sectionId, productId = null, variantId = null, productTitle = null) {
    // Fetch the section-rendered HTML for the new product
    const url = `/products/${handle}?section_id=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error(`Failed to fetch product section: ${res.status}`);
    const html = await res.text();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const targetContainer = document.querySelector('.pdp-header-steps');
    if (!targetContainer) return;

    targetContainer.querySelectorAll('[data-pdp-header]').forEach((targetEl) => {
      const key = targetEl.dataset.pdpHeader;

      // skip editions
      if (key === 'editions') return;

      const sourceEl = tempDiv.querySelector(`[data-pdp-header="${key}"]`);
      if (sourceEl) {
        targetEl.innerHTML = sourceEl.innerHTML;
      }
    });

    const productForm = document.querySelector('product-form');
    if (productForm) {
      if (productId) {
        const productIdField = productForm.querySelector('[name="product-id"]');
        if (productIdField) {
          productIdField.value = productId;
        }
        productForm.dataset.productId = productId;
      }

      if (variantId) {
        const variantIdField = productForm.querySelector('[name="id"]');
        if (variantIdField) {
          variantIdField.value = variantId;
        }
      }
    }

    if (productTitle) {
      const productTitleField = document.querySelector('span[data-selected-product-edition-title]');
      if (productTitleField) {
        productTitleField.textContent = `(${productTitle})`;
      }
    }

    // Re-run theme JS hooks
    document.dispatchEvent(new CustomEvent('product:reloaded', { detail: { handle, sectionId } }));
  }

  function pdpNewpaperEditionSelectorHandler() {
    // Handle newspaper edition change
    const newspaperEditionSelect = document.getElementById('newspaper_book_edition');

    if (newspaperEditionSelect) {
      newspaperEditionSelect.addEventListener('change', async function (e) {
        if (e.target.value === '') return;

        const pdpHeader = e.target.closest('[data-pdp-header]');
        if (pdpHeader) {
          pdpHeader.setAttribute('loading', '');
        }
        const productHandle = e.target.value;
        const sectionId = e.target.dataset.sectionId;

        const selectedOption = e.target.selectedOptions[0];
        const productId = selectedOption?.dataset?.productId || null;
        const productTitle = selectedOption?.dataset?.productTitle || null;
        const variantId = selectedOption?.dataset?.variantId || null;

        if (productHandle && productHandle !== '') {
          try {
            await pdpSwapProduct(productHandle, sectionId, productId, variantId, productTitle);
          } catch (err) {
            console.error(err);
            if (pdpHeader) {
              pdpHeader.removeAttribute('loading');
            }
            // As a fallback, you can navigate normally:
            window.location.href = `/products/${productHandle}`;
          }

          document.querySelectorAll('.pdp_header__cover-img-item').forEach((media_wrap) => {
            media_wrap.classList.add('hidden');
          });

          const escapedEditionValue =
            typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(this.value) : this.value;
          const matches = document.querySelectorAll('[data-npb-editions="' + escapedEditionValue + '"]');
          if (matches.length > 0) {
            matches[0].classList.remove('hidden');
          }

          // Remove 'open' and loading attribute from all pdp-header-step elements
          const allSteps = document.querySelectorAll('.pdp-header-step');
          allSteps.forEach((step) => {
            step.removeAttribute('open');
            step.removeAttribute('loading');
          });

          // Optionally, open the second step after reset
          const secondStep = document.querySelector('[data-pdp-header-step="2"]');
          if (secondStep) {
            secondStep.setAttribute('open', '');
            secondStep.setAttribute('visited', '');
          }
        }
      });
    }
  }

  function pdpAccordions() {
    const accordionBody = document.querySelector('.pdp-header__content .section-accordions__body');
    if (!accordionBody) return;

    // Prevent duplicate event listeners
    if (accordionBody.__pdpAccordionsListenerAttached) return;
    accordionBody.__pdpAccordionsListenerAttached = true;

    // Handle accordion step clicks
    accordionBody.addEventListener('click', function (e) {
      const clickedDetails = e.target.closest('.details');

      if (clickedDetails) {
        let currentStep = clickedDetails.getAttribute('data-pdp-header-step');
        // Guard against missing or non-numeric step values
        if (currentStep === null || currentStep === '') {
          currentStep = '1';
        }

        const currentStepNum = parseInt(currentStep, 10);

        // Close all previous steps
        for (let i = 1; i < currentStepNum; i++) {
          const prevStep = document.querySelector(`[data-pdp-header-step="${i}"]`);
          if (prevStep) {
            prevStep.removeAttribute('open');
          }
        }

        // Open next step if it exists and hasn't been opened yet
        if (currentStepNum > 1) {
          let nextSibling = clickedDetails.nextElementSibling;
          while (nextSibling) {
            if (nextSibling.classList.contains('details')) {
              // Only add 'open' if it doesn't exist
              if (!nextSibling.hasAttribute('open')) {
                nextSibling.setAttribute('open', '');
                nextSibling.setAttribute('visited', '');
              }
              break;
            }
            nextSibling = nextSibling.nextElementSibling;
          }
        }
        const pdpHeader = document.querySelector('#pdp-header-wrapper');
        const totalSteps = document.querySelectorAll('.pdp-header-steps .pdp-header-step');

        // resetting to initial state if user re-open the first step.
        if (totalSteps && currentStepNum < 2) {
          totalSteps.forEach((step) => {
            step.classList.remove('scrolled');
          });
        }

        // Determine whether the editions step actually exists, instead of inferring
        // from the total number of steps. When the editions step is present, the
        // cover-design step becomes step 2 and should not trigger scrolling.
        const editionsStep = document.querySelector('.pdp-header-steps .pdp-header-step[data-pdp-header="editions"]');
        const skipCoverStepNumber = editionsStep ? 2 : 1;

        if (pdpHeader && window.innerWidth <= 768 && currentStepNum > skipCoverStepNumber) {
          const HEADER_SCROLL_OFFSET = 120; // Offset to account for fixed PDP header height when scrolling

          const y = pdpHeader.getBoundingClientRect().top + window.scrollY - HEADER_SCROLL_OFFSET;
          if (!clickedDetails.classList.contains('scrolled')) {
            window.scrollTo({ top: y, behavior: 'smooth' });
            clickedDetails.classList.add('scrolled');
          }
        }
      }
    });
  }

  function pdpMakeAddToCartSticky() {
    // Check if device is mobile (width <= 768px)
    function isMobileDevice() {
      return window.innerWidth <= 768;
    }

    let observer = null;
    let placeholder = null;
    let isInitialized = false;

    function initializeStickyBehavior() {
      if (isInitialized || !isMobileDevice()) return;

      const actions_wrapper = document.querySelector('.main-product__actions-wrapper');
      const actions = document.querySelector('.main-product__actions');
      const pdp = document.querySelector('.main-product__pdp');

      // Check if required elements exist
      if (!actions_wrapper || !actions || !pdp) {
        console.warn('Required elements not found for sticky cart functionality');
        return;
      }

      // Create a placeholder to restore original position
      placeholder = document.createElement('div');
      placeholder.style.display = 'none'; // Hide placeholder visually
      actions.parentNode.insertBefore(placeholder, actions);

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              // If actions not visible → move to .main-product__pdp
              if (pdp.lastElementChild !== actions) {
                pdp.appendChild(actions);
                actions.classList.add('main-product__actions--bottom');
              }
            } else {
              // If visible again → restore to original place
              if (placeholder.parentNode && !placeholder.contains(actions)) {
                placeholder.parentNode.insertBefore(actions, placeholder);
                actions.classList.remove('main-product__actions--bottom');
              }
            }
          });
        },
        { threshold: 0, rootMargin: '-120px 0px 0px 0px' },
      );

      observer.observe(actions_wrapper);
      isInitialized = true;
    }

    function cleanupStickyBehavior() {
      if (!isInitialized) return;

      // Disconnect observer
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      // Restore original position
      const actions = document.querySelector('.main-product__actions');
      if (actions && placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(actions, placeholder);
        actions.classList.remove('main-product__actions--bottom');
        placeholder.remove();
        placeholder = null;
      }

      isInitialized = false;
    }

    function handleResize() {
      if (isMobileDevice() && !isInitialized) {
        initializeStickyBehavior();
      } else if (!isMobileDevice() && isInitialized) {
        cleanupStickyBehavior();
      }
    }

    // Initialize on mobile devices
    if (isMobileDevice()) {
      initializeStickyBehavior();
    }

    // Monitor screen resize with a single global handler to avoid duplicates
    if (window.__pdpStickyResizeHandler) {
      window.removeEventListener('resize', window.__pdpStickyResizeHandler);
    }
    // Ensure the timeout reference exists on window (shared across calls)
    if (typeof window.__pdpStickyResizeTimeout === 'undefined') {
      window.__pdpStickyResizeTimeout = null;
    }

    window.__pdpStickyResizeHandler = function pdpStickyResizeHandler() {
      // Debounce resize events for better performance
      if (window.__pdpStickyResizeTimeout) {
        clearTimeout(window.__pdpStickyResizeTimeout);
      }
      window.__pdpStickyResizeTimeout = setTimeout(handleResize, 150);
    };
    window.addEventListener('resize', window.__pdpStickyResizeHandler);

    // Return cleanup function for manual cleanup if needed
    return function cleanup() {
      cleanupStickyBehavior();
      if (window.__pdpStickyResizeHandler) {
        window.removeEventListener('resize', window.__pdpStickyResizeHandler);
      }
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    pdpNewpaperEditionSelectorHandler();
    pdpAccordions();
    pdpMakeAddToCartSticky();

    // Bind only once even if snippet is included multiple times
    if (!window.__pdpStickyBound) {
      window.__pdpStickyBound = true;
      document.addEventListener('product:reloaded', pdpAccordions);
      document.addEventListener('product:reloaded', pdpMakeAddToCartSticky);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-giftboxes"] && !Shopify.designMode) return;
  try {
    function handleGiftboxRadios() {
    // Make radio inputs with class `custom-tick-marker` disable all other radios
    // when one is selected. Clicking or activating an already-selected radio
    // will clear it and re-enable all radios. Handles pointer/mouse/touch/keyboard.
    function initGiftboxRadios() {
      try {
        const radios = Array.from(document.querySelectorAll('input.custom-tick-marker[type="radio"]'));
        if (!radios.length) return;

        radios.forEach((radio) => {
          // Avoid re-initializing the same radio after AJAX updates
          if (radio.dataset.giftboxInitialized === 'true') return;
          radio.dataset.giftboxInitialized = 'true';

          // Record checked state before activation (mouse/touch/pointer/keyboard)
          function storeWasChecked() {
            radio.dataset.wasChecked = radio.checked ? 'true' : 'false';
          }

          radio.addEventListener('pointerdown', storeWasChecked);
          radio.addEventListener('mousedown', storeWasChecked);
          radio.addEventListener('touchstart', storeWasChecked);
          radio.addEventListener('keydown', function (e) {
            if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') storeWasChecked();
          });

          // Also listen on the label associated with this radio so clicks on the
          // label record the radio's pre-click checked state (covers label-for
          // and wrapping-label patterns).
          var labelEl = null;
          try {
            if (radio.id) labelEl = document.querySelector('label[for="' + radio.id + '"]');
            if (!labelEl) labelEl = radio.closest('label');
          } catch (e) {
            labelEl = null;
          }

          if (labelEl) {
            labelEl.addEventListener('pointerdown', storeWasChecked);
            labelEl.addEventListener('mousedown', storeWasChecked);
            labelEl.addEventListener('touchstart', storeWasChecked);
          }

          radio.addEventListener('click', function (e) {
            const wasChecked = this.dataset.wasChecked === 'true';
            delete this.dataset.wasChecked;

            if (wasChecked) {
              // Some browsers will re-apply the radio's checked state after click.
              // Defer the uncheck to the next tick to reliably override that behavior.
              e.preventDefault();
              const self = this;
              setTimeout(function () {
                self.checked = false;
                radios.forEach((r) => (r.disabled = false));
                // Emit change so any other listeners react
                self.dispatchEvent(new Event('change', { bubbles: true }));
                // Remove focus so keyboard users don't immediately re-toggle
                self.blur();
              }, 0);
            } else {
              // Newly checked: disable all other radios
              radios.forEach((r) => {
                if (r !== this) r.disabled = true;
              });
            }
          });
        });
      } catch (err) {
        // Fail silently to avoid breaking the page
        // eslint-disable-next-line no-console
        console.error('giftboxes radio toggle error', err);
      }
    }

    // Debounce helper to avoid rapid re-inits during batch DOM updates
    function debounce(fn, wait) {
      let t = null;
      return function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fn();
        }, wait);
      };
    }

    var debouncedInit = debounce(initGiftboxRadios, 50);

    // Initial run
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGiftboxRadios);
    } else {
      initGiftboxRadios();
    }

    // Observe DOM changes so radios re-init after AJAX updates
    try {
      var observerRoot = document.currentScript ? document.currentScript.parentNode : document.body;
      if (!window.__giftboxObserver) {
        window.__giftboxObserver = new MutationObserver(function (mutations) {
          // Only trigger when relevant nodes change to reduce work
          for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (m.type === 'childList' || m.type === 'attributes') {
              debouncedInit();
              break;
            }
          }
        });

        window.__giftboxObserver.observe(observerRoot, {
          childList: true,
          subtree: true,
          attributes: false,
        });
      }
    } catch (e) {
      // ignore observer errors
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    handleGiftboxRadios();

    // Bind only once even if snippet is included multiple times
    if (!window.__productGiftboxRadios) {
      window.__productGiftboxRadios = true;
      document.addEventListener('product:reloaded', handleGiftboxRadios);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
